// Helper function to check if attribution is locked
export const isLockedAttribution = (
  value: string | null | undefined,
): boolean => {
  return value === 'whitelist_locked' || value === 'premium_locked';
};
